<!-- <p>product-listing works!</p> -->
<div class="mobile_filter_overlay" (click)="openSortOption()" *ngIf="sortShow"></div>
<div class="product_listing_cont_outer">
	<div class="select_trigger_cont">
		<button class="SelectTrigger_button {{sortShow?'active_sort_menu':''}}" (click)="openSortOption()">
			<span class="material-symbols-outlined deskshow" *ngIf="!sortShow">
				sort
			</span>
			<span class="deskhide">SORT BY</span>
			<span class="material-symbols-outlined" *ngIf="sortShow">
				close
			</span>
			<span class="sort_text">sort by</span>
		</button>

		<div class="select" [@enterAnimation] *ngIf="sortShow">
			<div class="option {{selectedSortOption=='date'?'active_sort_option':''}}" (click)="sort('date')">
				New Arrival
			</div>
			<div class="option {{selectedSortOption=='l_t_h'?'active_sort_option':''}}" (click)="sort('l_t_h')">
				Price Low To High
			</div>
			<div class="option {{selectedSortOption=='h_t_l'?'active_sort_option':''}}" (click)="sort('h_t_l')">
				Price High To Low
			</div>
		</div>
	</div>

	<div class="product_listing_cont_inner">
		<ng-container *ngIf="isLoading">
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>
			<fb-skeleton-product-item class="product_item_ind_cont"></fb-skeleton-product-item>

		</ng-container>
		<ng-container *ngFor="let product of productListingForView">
			<fb-product-item class="product_item_ind_cont" [productListingData]="product"
							 [selectedCurrency]="selectedCurrency"></fb-product-item>
		</ng-container>


		<fb-product-not-found *ngIf="!isLoading && this.productListing.length<1" class="no_product_found"></fb-product-not-found>

		<div class="load_more_button_cont" #testDiv>
			<button class="load_more" (click)="loadMoreClicked()"
				*ngIf=" (startIndex+numberOfItemPerPage) < (productListing.length)">
				Load more
				<!-- ( startIndex-{{startIndex}},startIndexwithThree-{{startIndex+3}}, originalLen-{{productListing.length}},numberOfItemPerPage-{{numberOfItemPerPage}} )  {{(endIndex)*numberOfItemPerPage}} -->
			</button>
		</div>
	</div>

</div>
